import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { REACT_APP_GLOBAL_API_BASE_URL_V2 } from 'runtimeEnvVars';

import {
  addNewMessageAction,
  removeApplicantMessageAction,
} from 'containers/ApplicantTableV2/actions';
import {
  addDefaultErrorMessageAction,
  addMessageAction,
} from 'containers/FlashMessage/actions';
import { apiPost } from 'utils/axios';
import { isNumberOptedOutRefusal } from 'utils/numberOptedOutRefusal';

export default function useResendMessage(applicantId) {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const handleResend = async messageId => {
    setIsLoading(true);
    const url = `${REACT_APP_GLOBAL_API_BASE_URL_V2}/applicants/${applicantId}/messages/${messageId}/resend`;

    try {
      const res = await apiPost(url);
      if (res.data) {
        // POST - resend creates new Message object in db
        // swap old message with failed status with newly created message
        dispatch(removeApplicantMessageAction(applicantId, messageId));
        dispatch(addNewMessageAction(applicantId, res.data.message));
      }
    } catch (e) {
      if (isNumberOptedOutRefusal(e)) {
        // Nothing was sent and another Resend gets the same answer, so the
        // toast stays until the recruiter closes it.
        dispatch(addMessageAction(e.message, 'error', false));
      } else {
        dispatch(addDefaultErrorMessageAction());
      }
    } finally {
      setIsLoading(false);
    }
  };

  return { handleResend, isLoading };
}
